import { DropdownTabsModel } from "@core/models/dropdown-tabs.model";

export const dropdownConfig: DropdownTabsModel = [
  {
    title: "Communic8",
    baseURL: "communic8",
    roles: [
      "hubio-c8-download"
    ],
    links: [
      {
        label: "Files",
        icon: "description",
        route: "communic8"
      },
      {
        label: "Agents",
        icon: "group",
        route: "communic8/agents"
      }
    ]
  }
]